import React from "react";
import { ErrorMessage } from "react-hook-form";
import { parse, format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";

const DATE_FORMAT = "MM/dd/yyyy";

const InputDatePicker = ({
  label,
  name,
  errors,
  register,
  clearError,
  disabledDay,
  disabledOperator = "before",
  value,
  disabled,
}) => {
  const parseDate = (str) => {
    const parsed = parse(str, DATE_FORMAT, new Date());

    if (DateUtils.isDate(parsed)) {
      return parsed;
    }
    return undefined;
  };

  const formatDate = (date) => format(utcToZonedTime(date), DATE_FORMAT);

  const handleOnDayChange = (day) => {
    if (day) {
      clearError(name);
    }
  };

  const disabledDays = (day) => {
    if (!disabledDay) return false;
    const disabled =
      disabledOperator === "after"
        ? DateUtils.isDayAfter(new Date(day), new Date(disabledDay))
        : DateUtils.isDayBefore(new Date(day), new Date(disabledDay)) ||
          DateUtils.isSameDay(new Date(day), new Date(disabledDay));

    return disabled;
  };

  return (
    <>
      <label
        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        htmlFor={name}>
        {label}
      </label>
      <DayPickerInput
        style={{ display: "flex", flexDirection: "column" }}
        formatDate={formatDate}
        format={DATE_FORMAT}
        parseDate={parseDate}
        onDayChange={handleOnDayChange}
        value={value && formatDate(new Date(value))}
        dayPickerProps={{
          disabledDays: disabledDays,
        }}
        inputProps={{
          ref: register,
          className: `appearance-none block w-full bg-gray-200 border ${
            errors[name] ? "border-red-500" : "border-gray-200"
          } rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 ${
            disabled ? "text-gray-500" : "text-gray-700"
          }`,
          placeholder: `${formatDate(new Date())}`,
          name: name,
          disabled,
        }}
      />
      {errors[name] ? (
        <ErrorMessage
          errors={errors}
          name={name}
          message="Please fill out this field"
          as="p"
          className="text-red-500 text-xs italic"
        />
      ) : (
        <p style={{ height: 18 }}></p>
      )}
    </>
  );
};

export default InputDatePicker;
